import React from "react";
import { Form, Input, Modal as AntdModal, Select, InputNumber,Row,Col, message } from "antd";
 

const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 36 },
    sm: { span: 18 },
  },
}; 

const Modal = (props) => {

  const { form,current,visible,onAdd=()=>{},onCancel=()=>{},getContainer,onEdit=()=>{} }=props;

  const handleConfirm=()=>{
     form.validateFields((err, values) => {
      if (!err) {
        if(current.capsuleId){
          onEdit({...values,capsuleId:current.capsuleId})
        }else{
          onAdd(values) 
        }
     
      }
    });
  }

  return ( 
    <AntdModal
      destroyOnClose={true}
      title={current?.capsuleId ? "编辑设备" : "添加设备"}
      visible={visible}
      onOk={handleConfirm}
      onCancel={onCancel} 
      width={710}
      wrapClassName={"modal"}
      getContainer={getContainer}
    >
      <Form  {...formItemLayout}>
        <Form.Item label="控制板编号">
          {form.getFieldDecorator(
            "roboId",
            current.roboId
              ? {
                  initialValue: current.roboId,
                  rules: [{ required: true, message: "请输入控制板编号" }],
                }
              : {
                  rules: [{ required: true, message: "请输入控制板编号" }],
                }
          )(
            <Input placeholder="请输入控制板编号" style={{width:324}} />
          )}
        </Form.Item> 
        <Form.Item label="设备编号">
          {form.getFieldDecorator("capsuleNo", {
            initialValue: current.capsuleNo,
            rules: [{ required: true, message: "请输入设备编号" }],
          })(<Input placeholder="请输入设备编号" style={{width:324}}  />)}
        </Form.Item> 
       
      </Form>
    </AntdModal>
  );
};

export default Form.create()(Modal);
